export * from './lib/my-account.module';
